<template>
  <!-- 对齐 App setting.dart：AppHeader + 白色 Card（顶部圆角 30 + 10.w 上边距）+ 6 行 item（itemColor 背景） -->
  <div class="settings-page">
    <app-header :title="i18n.title"></app-header>

    <div class="settings-card">
      <!-- Language -->
      <div class="settings-item" @click="onLanguage">
        <span class="settings-item-label">{{ i18n.lang }}</span>
        <span class="settings-item-arrow">›</span>
      </div>

      <!-- User Agreement -->
      <div class="settings-item" @click="onUserAgreement">
        <span class="settings-item-label">{{ i18n.user_agreement }}</span>
        <span class="settings-item-arrow">›</span>
      </div>

      <!-- Privacy Policy -->
      <div class="settings-item" @click="onPrivacyPolicy">
        <span class="settings-item-label">{{ i18n.privacy_policy }}</span>
        <span class="settings-item-arrow">›</span>
      </div>

      <!-- Logout -->
      <div class="settings-item" @click="onLogout">
        <span class="settings-item-label">{{ i18n.logout }}</span>
        <span class="settings-item-arrow">›</span>
      </div>

      <!-- Delete Account (hidden)
      <div class="settings-item" @click="onDeleteAccount">
        <span class="settings-item-label">{{ i18n.delete_account }}</span>
        <span class="settings-item-arrow">›</span>
      </div> -->

      <!-- Time zone (无箭头，右侧显示 GMT 值) -->
      <div class="settings-item settings-item-zone">
        <span class="settings-item-label">{{ i18n.time_zone }}</span>
        <span class="settings-item-value">{{ timeZoneText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../../components/common/AppHeader.vue"

export default {
  components: {
    AppHeader
  },
  computed: {
    i18n() {
      return this.$t("settings")
    },
    // 对齐 App setting.dart L80：DateTime.now().timeZoneOffset.inHours
    // JS getTimezoneOffset() 返回分钟，且东时区为负，所以要取反除以 60
    timeZoneText() {
      const offsetHours = -new Date().getTimezoneOffset() / 60
      const sign = offsetHours >= 0 ? "+" : ""
      return `GMT${sign}${offsetHours}`
    }
  },
  methods: {
    onLanguage() {
      this.$router.push("/settings/language")
    },
    onUserAgreement() {
      // 与 login_phone.vue L104 一致：${VUE_APP_DOMAIN}/content/user_agreement.html
      const url = `${process.env.VUE_APP_DOMAIN}/content/user_agreement.html`
      window.open(url)
    },
    onPrivacyPolicy() {
      const url = `${process.env.VUE_APP_DOMAIN}/content/privacy_policy.html`
      window.open(url)
    },
    onLogout() {
      // 对齐 App setting.dart L91 _showLogoutDialog
      this.$confirm({
        title: this.i18n.msg_title,
        content: this.i18n.sure_logout,
        confirmText: this.i18n.confirm,
        cancelText: this.i18n.cancel
      })
        .then(() => {
          this.$store.commit("user", null)
          this.$store.commit("token", null)
          this.$router.push("/login")
        })
        .catch(() => {})
    },
    onDeleteAccount() {
      // 对齐 App setting.dart L120 _showDeleteAccountDialog
      // 完整流程需校验未完成订单 + 删除绑卡 + cancelAccount，H5 端先弹确认
      this.$confirm({
        title: this.i18n.msg_title,
        content: this.i18n.sure_delete_account,
        confirmText: this.i18n.confirm,
        cancelText: this.i18n.cancel
      })
        .then(() => {
          // H5 端暂未实现 deleteAccount API，先跳登录页占位
          this.$store.commit("user", null)
          this.$store.commit("token", null)
          this.$router.push("/login")
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less">
/* 对齐 App setting.dart：
   pageBackgroundColor = white, cardColor = white（顶部圆角 30 + 10.w 上边距）
   itemColor = #f8f6fc（每个 item 自己的背景） */
.settings-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #fff; /* pageBackgroundColor */
  display: flex;
  flex-direction: column;
}

.settings-card {
  background: #fff; /* cardColor */
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  /* 10.w ≈ 17px（App 端 428 设计稿在 H5 750 稿上的换算） */
  margin-top: 17px;
  /* 30.w 顶部留白 ≈ 52px（对应 App dart margin: EdgeInsets.only(top: 10) + padding top: 30） */
  padding: 52px 0 30px;
}

/* item：60.w 高 ≈ 105px，30.w 水平 margin ≈ 52px，10.w 垂直 margin ≈ 17px，圆角 10 ≈ 17px
   border lineColor 同 itemColor（#f8f6fc），实际上看不出 */
.settings-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 105px;
  margin: 0 52px 17px;
  padding: 0 28px; /* 16.w ≈ 28px */
  background: #f8f6fc; /* itemColor */
  border: 1px solid #f8f6fc; /* lineColor，与 itemColor 同色 */
  border-radius: 17px; /* 10.w ≈ 17px */
  box-sizing: border-box;
  cursor: pointer;
  font-family: "Montserrat-Medium", sans-serif;
}

.settings-item-label {
  font-size: 32px; /* 16.sp ≈ 28px, 这里用 32px 适配 H5 750 稿 */
  font-weight: 500;
  color: #000; /* textColor */
  flex: 1;
}

.settings-item-arrow {
  flex-shrink: 0;
  font-size: 40px;
  font-weight: 400;
  color: #000; /* subTextColor, App 端是 Icons.chevron_right */
  line-height: 1;
  opacity: 0.5;
  transform: scale(1, 1.5);
}

.settings-item-value {
  flex-shrink: 0;
  font-size: 32px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5); /* subTextColor */
  font-family: "Montserrat-Regular", sans-serif;
}
</style>
